import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboardWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconClapboardWide"><Path d="M22 20H2V10H22V20Z" fill="currentColor"/><Path d="M6.5 8H2V4H8.09961L6.5 8Z" fill="currentColor"/><Path d="M13.7471 8H8.65332L10.2529 4H15.3467L13.7471 8Z" fill="currentColor"/><Path d="M22 8H15.9004L17.5 4H22V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboardWide;
